var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Link = require('react-router').Link;

var ProfileFAQList = createReactClass({
	mixins: [PureRenderMixin],

    render: function(){
        return (
			<ul className="profile-faq-list no-bullet">
                <li>
                    <h3 className="question">Is my information private &amp; secure?</h3>
                    <div className="answer">
                        <p>MyGiHealth maintains the highest security standards to keep your info safe. See our <Link to="/privacy">privacy policy</Link> for related information.</p>
                    </div>
                </li>
                <li>
                    <h3 className="question">How do I change my password?</h3>
                    <div className="answer">
                        <p>Click the "Reset Password" <span className="show-for-medium">link</span><span className="hide-for-medium">button</span> and follow the instructions given.</p>
                    </div>
                </li>
                <li>
                    <h3 className="question">How do I sign out of my account?</h3>
                    <div className="answer">
                        <p>Click the "Log Out" button.</p>
                    </div>
                </li>
                <li>
                    <h3 className="question">How do I change my email address?</h3>
                    <div className="answer">
                        <p>At this time, we do not allow email address changes.</p>
                    </div>
                </li>
                <li>
                    <h3 className="question">How do I delete my account?</h3>
                    <div className="answer">
                        <p>Please <Link to="/contact">contact us</Link> for more information.</p>
                    </div>
                </li>
            </ul>
        )
    }
});

module.exports = ProfileFAQList;



// WEBPACK FOOTER //
// ./src/common/routes/profile/components/layout/profileFAQList.jsx